/**
 * @fileoverview GET handler for the "/oauth/applications/:client_id" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError, reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { oauthApplicationsClientId } from "./constants";
import type { GetOAuthApplicationDataError, OAuthApplicationResult } from "./types";
import { isOAuthApplicationResult } from "./validators";

export const getOAuthApplicationData = reactQueryFetcherAdapter(
  oauthApplicationsClientId,
  createGetFetcherFunctionWithShadowError<GetOAuthApplicationDataError>()(
    (signal: AbortSignal, clientId: string): Promise<OAuthApplicationResult> => {
      // CIMD client IDs are URLs, so encode them as a single path segment.
      return fetch(
        `/oauth/applications/${encodeURIComponent(clientId)}`,
        "GET",
        {},
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isOAuthApplicationResult
);
